import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import dayjs from 'dayjs';
import {
  Card,
  Container,
  Grid,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Tooltip,
  Box,
  CircularProgress,
} from '@mui/material';
import AutoModeIcon from '@mui/icons-material/AutoMode';
import ContentPasteSearchIcon from '@mui/icons-material/ContentPasteSearch';
import { usePopup } from '../../../context/PopupContext';
import { CustomIconButton, DefaultContainedButton } from '../../../utils/Buttons';
import { CommonLabel } from '../../../utils/Common';
import API from '../../../api';
import { LoadingUI } from '../../../utils/LayoutStyles';

export default function BankPaymentBatchDetail() {
  const { state } = useLocation();
  const batchID = state.batchID;
  const batchNO = state.batchNo;

  const [batch, setBatch] = useState({});
  const [batchChildren, setBatchChildren] = useState([]);
  const [isApiLoading, setIsApiLoading] = useState(true);

  useEffect(() => {
    API.get(`/bankpaybatch/${batchID}`)
      .then((response) => {
        setBatch(response.data.parent);
        setBatchChildren(response.data.parent.child);
        setIsApiLoading(false);
      })
      .catch((error) => {
        setIsApiLoading(false);
      });
  }, []);

  const { showPopup, setPopUpText } = usePopup();

  return (
    <>
      <Helmet>
        <title>Bank Transfers</title>
      </Helmet>

      <Container maxWidth="xl">
        <Grid container spacing={3} sx={{ paddingTop: '24px' }}>
          <Grid item xs={12}>
            <Card sx={{ padding: '24px' }}>
              {!isApiLoading ? (
                <Stack direction="row" alignItems="start" justifyContent="space-between">
                  <Stack direction="column" gap="8px">
                    <Stack direction="row" gap="8px">
                      <Typography sx={{ fontWeight: 'bold' }}>Data Creazione:</Typography>
                      <Typography>{dayjs(batch.creation_date).format('DD/MM/YYYY')}</Typography>
                    </Stack>
                    <Stack direction="row" gap="8px">
                      <Typography sx={{ fontWeight: 'bold' }}>Batch n°:</Typography>
                      <Typography>{batchNO}</Typography>
                    </Stack>
                    <Stack direction="row" gap="8px">
                      <Typography sx={{ fontWeight: 'bold' }}>Processed:</Typography>
                      <CommonLabel
                        textColor={batch.completed ? '#118d57' : '#b71d18'}
                        bgColor={batch.completed ? '#d3efdf' : '#f7ddd8'}
                        text={batch.completed ? 'Riconciliato' : 'Non trovato'}
                      />
                    </Stack>
                  </Stack>
                  <Stack direction="row" alignItems="start" justifyContent="end">
                    <DefaultContainedButton startIcon={<AutoModeIcon />}>Elabora Dati</DefaultContainedButton>
                  </Stack>
                </Stack>
              ) : (
                <Stack direction="row" justifyContent="center" alignItems="center">
                  <CircularProgress />
                </Stack>
              )}
            </Card>
          </Grid>

          <Grid item xs={12}>
            <Card sx={{ padding: '24px' }}>
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Nome Banca</TableCell>
                      <TableCell>Intestatario</TableCell>
                      <TableCell>Data Trasferimento</TableCell>
                      <TableCell>Data Registrazione Trasferimento</TableCell>
                      <TableCell>Totale</TableCell>
                      <TableCell>Valuta</TableCell>
                      <TableCell>Causale</TableCell>
                      <TableCell>Processed</TableCell>
                      <TableCell />
                    </TableRow>
                  </TableHead>
                  {!isApiLoading ? (
                    <TableBody>
                      {batchChildren.length > 0 ? (
                        batchChildren.map((child) => (
                          <TableRow hover key={child.id}>
                            <TableCell>{child.bank_name}</TableCell>
                            <TableCell>{child.bank_owner_name}</TableCell>
                            <TableCell>{dayjs(child.transfer_date).format('DD/MM/YYYY')}</TableCell>
                            <TableCell>{dayjs(child.transfer_registration_date).format('DD/MM/YYYY')}</TableCell>
                            <TableCell>{child.amount}€</TableCell>
                            <TableCell>{child.currency}</TableCell>
                            <TableCell>{child.bank_transfer_reason}</TableCell>
                            <TableCell>
                              <CommonLabel
                                textColor={child.processed ? '#007867' : '#b71d18'}
                                bgColor={child.processed ? '#22c55e29' : '#ff563029'}
                                text={child.processed ? 'Attiva' : 'Scaduta'}
                              />
                            </TableCell>
                            <TableCell>
                              <Tooltip title="Cerca Manualmente" arrow>
                                <Box>
                                  <CustomIconButton>
                                    <ContentPasteSearchIcon />
                                  </CustomIconButton>
                                </Box>
                              </Tooltip>
                            </TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <TableRow>
                          <TableCell colSpan={8} sx={{ textAlign: 'center' }}>
                            Nessun pagamento disponibile
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  ) : (
                    <TableBody>
                      <TableRow>
                        <TableCell colSpan={8} sx={{ textAlign: 'center' }}>
                          {LoadingUI()}
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </>
  );
}
